<ng-container>
  <mat-form-field>
    <input
      required
      type="text"
      [readonly]="isTeamAdmin"
      [formControl]="selectedTeamControl"
      [placeholder]="'dataCollection.FilterExportDialog.Fields.TeamSlug' | translate"
      matInput
      [matAutocomplete]="auto"
      autocomplete="off"
      multiple
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayTeamProperty.bind(this)">
      <mat-option *ngFor="let team of filteredTeamsData$ | async" [value]="team">
        {{ getTeamDisplayValue(team) }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>
